import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {DispatchAny} from '@pluto/@types';
import CircularProgress from '@material-ui/core/CircularProgress';
import {useParams} from 'react-router-dom';
import wrap from 'wraptile';
import {selectDeliveryManagerManifest} from './Redux/DeliveryManagerManifestSelectors';
import BlueEvoContainer from '../../../Ingest/IngestData/Providers/BlueEvo';
import {
    getDeliveryManagerManifestAction,
    resetDeliveryManagerManifestAction,
} from './Redux/DeliveryManagerManifestAction';

const {parse} = JSON;

export const handleUnmount = wrap((dispatch: DispatchAny) => {
    dispatch(resetDeliveryManagerManifestAction());
});

export const handleEffect = wrap((dispatch: DispatchAny, id: string, onUnmount: () => {}) => {
    dispatch(getDeliveryManagerManifestAction({
        id,
    }));

    return onUnmount;
})

export default function DeliveryManagerManifestContainer() {
    const {id} = useParams<{id: string}>();

    const dispatch = useDispatch();
    const {isLoading, url} = useSelector(selectDeliveryManagerManifest);
    const onUnmount = handleUnmount(dispatch);
    const onEffect = handleEffect(dispatch, id, onUnmount);

    useEffect(onEffect, []);

    if (isLoading) {
        return <CircularProgress/>;
    }
    return (
        <BlueEvoContainer
            isDeliveryManagerManifest={true}
            id={id}
            isEditable={false}
            data={parse(url)}
        />
    );
}
